module.exports = __webpack_public_path__ + "img/05.0b2953df.png";